export default function DataTablePagination(){
  return {
    restrict: "E",
    scope:{
      "source":"="
    },
    template: require("./DataTablePagination.html"),
    link: function(scope, element, attr){
      scope.currentPage = 1;
      scope.pageChanged = function(){
        scope.source.offset = (scope.currentPage-1) * scope.source.limit;
        scope.source.load();
      }
    }    
  }
}


// WEBPACK FOOTER //
// ./src/DataTable/DataTablePagination.js